<template>
  <PersonalLabelTemplateTableActionCell
    :label="label"
    v-if="column.dataIndex === 'actions' && !common"
  />

  <CommonLabelTemplateTableActionCell
    :label="label"
    v-if="column.dataIndex === 'actions' && common"
  />

  <LabelTemplateTablePrinterCell
    :label="label"
    v-else-if="column.dataIndex === 'attachedPrinterName'"
  />

  <a-flex v-else justify="center" alignItems="center">
    <a-typography-text>{{ label[column.dataIndex] }}</a-typography-text>
  </a-flex>
</template>

<script setup lang="ts">
import type { LabelTemplateTableData } from "@/stores/labelTemplate/labelTemplateStore";
import type { TableColumn } from "@/types/table";
import PersonalLabelTemplateTableActionCell from "@/components/settings/labels/labelTemplateTable/PersonalLabelTemplateTableActionCell.vue";
import LabelTemplateTablePrinterCell from "@/components/settings/labels/labelTemplateTable/LabelTemplateTablePrinterCell.vue";
import CommonLabelTemplateTableActionCell from "@/components/settings/labels/labelTemplateTable/CommonLabelTemplateTableActionCell.vue";

defineProps<{
  label: LabelTemplateTableData;
  column: TableColumn<LabelTemplateTableData>;
  isAdminAccount?: boolean;
  isPermissionEnabled?: boolean;
  common?: boolean;
}>();
</script>

<style scoped lang="scss"></style>
